import { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './FormInput.module.css';

function EyeIcon({ visible }) {
  const Comp = visible ? Eye : EyeOff;
  return <Comp size={20} strokeWidth={1.8} />;
}

export default function FormInput({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  success,
  disabled,
  suffix,
  inputMode,
  maxLength,
  name,
  autoComplete,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  // 라벨 · 도움말을 input과 프로그램적으로 연결한다.
  // 없으면 라벨을 눌러도 포커스가 가지 않고, 스크린리더는 placeholder만 읽는다.
  const id = useId();
  const msgId = `${id}-msg`;
  const hasMsg = Boolean(error || success);

  return (
    <div className={styles.field}>
      {label && <label className={styles.label} htmlFor={id}>{label}</label>}
      <div className={styles.inputWrap}>
        <input
          id={id}
          name={name}
          autoComplete={autoComplete}
          type={inputType}
          className={`${styles.input} ${error ? styles.inputError : ''} ${isPassword ? styles.inputPasswordPad : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          inputMode={inputMode}
          maxLength={maxLength}
          aria-invalid={error ? true : undefined}
          aria-describedby={hasMsg ? msgId : undefined}
        />
        {isPassword && (
          <button
            type="button"
            className={styles.eyeBtn}
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 표시'}
            aria-pressed={showPassword}
          >
            <EyeIcon visible={showPassword} />
          </button>
        )}
        {suffix && <div className={styles.suffix}>{suffix}</div>}
      </div>
      {error && <p className={styles.errorMsg} id={msgId} role="alert">{error}</p>}
      {success && <p className={styles.successMsg} id={msgId}>{success}</p>}
    </div>
  );
}
